module.exports = __webpack_public_path__ + "static/3-NW-Corner-Part-Aerial-View-5653578de270b550f5519140cb53b8fe.jpg";